import { usePartDefinition } from "@project/emerge";
import type { AbstractPartDefinition } from "@project/emerge-types";
import type { LTPartType } from "../enum/PartType";
import { PartEdges } from "./PartEdges";

// Definiere einen passenden Typ für den Renderer
interface RunnerRendererProps
  extends AbstractPartDefinition<LTPartType.SlideRail> {
  partSelection: {
    strength?: number;
  };
  size: {
    x?: number;
    y?: number;
  };
}

export const RunnerRenderer = ({ id }: { id: string }) => {
  // Nur die Eigenschaften abonnieren, die für das Rendering benötigt werden
  const partDef = usePartDefinition<RunnerRendererProps>({
    id,
    select: ["partSelection", "size"],
  });

  if (!partDef) return null;

  const { partSelection, size } = partDef;

  // Get dimensions from partSelection and properties
  const width = size.y || 50;
  const length = size.x || 600;
  const thickness = partSelection.strength || 9;

  return (
    <group>
      {/* Main runner plank */}
      <mesh position={[0, 0, 0]}>
        <boxGeometry args={[length, thickness, width]} />
        <meshStandardMaterial color="#8B4513" roughness={0.5} />
        <PartEdges />
      </mesh>
    </group>
  );
};
